import script from "./sample-record.vue?vue&type=script&setup=true&lang=js"
export * from "./sample-record.vue?vue&type=script&setup=true&lang=js"

import "./sample-record.vue?vue&type=style&index=0&id=4ee8cb32&scoped=true&lang=css"

import exportComponent from "E:\\茂侨项目文件夹\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ee8cb32"]])

export default __exports__